<div class="content">
  <rd-shared-icon
    class="icon-not-found"
    [iconSymbol]="'icon-not-found'"
    [iconTheme]="'error'"></rd-shared-icon>
  <h1 class="page-not-found-header">
    {{ 'core.page_not_found.header' | translate }}
  </h1>
  <p class="page-not-found-description">
    {{ 'core.page_not_found.description' | translate }}
  </p>
</div>
